/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { useAccount, useDisconnect } from "wagmi";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { switchChain } from "@wagmi/core";
import React, { useState, useEffect, useContext, createContext } from "react";
import { wagmiConfig } from "../config/wagmiConfig";
import { errorTexts, generalIcons, vanarChainId } from "../utils/constants";

export const AppContext = createContext(null);

const AppRootContext = ({ children }) => {
  AppRootContext.propTypes = {
    children: PropTypes.any,
  };

  const [currentChain, setCurrentChain] = useState();
  const [isSignWallet, setIsSignWallet] = useState(
    !!localStorage?.getItem("wagmai_signature")
  );
  const [isSwitching, setIsSwitching] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [openWalletModal, setOpenWalletModal] = useState(false);
  const [walletSidebarOpen, setWalletSidebarOpen] = useState(false);

  const { pathname } = window.location;
  const { connector, address, isConnected} = useAccount();
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const {disconnect} = useDisconnect();
  const [isAuthenticated, setIsAuthenticated] = useState(
    address && isSignWallet ? true : false
  );
  const [disconnectCalled, setDisconnectCalled] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 1180px)" });

  const handleToggleWalletSidebar = () => {
    setWalletSidebarOpen((prev) => !prev);
  };

  const handleSignWallet = (isSign) => {
    setIsSignWallet(isSign);
  };

  const handleDisconnectWallet = () => {
    setDisconnectCalled(true);
    setIsSignWallet(false);
    setIsAuthenticated(false);
    localStorage.clear();
    disconnect();
  };

  const switchChainId = async (newNetwork) => {
    try {
      setIsSwitching(true);
      await switchChain(wagmiConfig, { chainId: newNetwork });
      setSelectedNetwork(newNetwork);
      setIsSwitching(false);
    } catch (error) {
      setIsSwitching(false);
      setSelectedWallet(null);
      if(!isSignWallet){
        handleDisconnectWallet();
      }
      toast.error(
        <div className="flex items-center gap-4">
          <span className="icon">{generalIcons.error}</span>
          <div className="">
            <p>{errorTexts.network}</p>
          </div>
        </div>
      );
      // throw(error);
    }
  };

  useEffect(() => {
    if (!isSignWallet && pathname?.includes("my-account")) {
      window.location.pathname = "/";
    }
  }, [pathname, isSignWallet]);

  useEffect(() => {
    const localDefaultChain = localStorage?.getItem("-walletlink:https://www.walletlink.org:DefaultChainId");
    if(localDefaultChain && !isConnected){
      localStorage?.removeItem("-walletlink:https://www.walletlink.org:DefaultChainId");
    }
    setSelectedNetwork(Number(vanarChainId));
  }, []);

  // useEffect(() => {
  //   if (isMobile) {
  //     if (pathname !== "/") {
  //       setTimeout(() => {
  //         const a = document.createElement("a");
  //         a.href = document.location.origin;
  //         a.click();
  //       }, 1000);
  //     }
  //   }
  // }, []);

  const contextValues = React.useMemo(
    () => ({
      address,
      isSignWallet,
      setIsSignWallet,
      selectedNetwork,
      openWalletModal,
      handleSignWallet,
      walletSidebarOpen,
      setOpenWalletModal,
      handleToggleWalletSidebar,
      switchChainId,
      connector,
      setSelectedNetwork,
      currentChain,
      isSwitching,
      setIsSwitching,
      isDisabled,
      setIsDisabled,
      selectedWallet, setSelectedWallet,
      isConnected,
      isAuthenticated, setIsAuthenticated,
      disconnectCalled, setDisconnectCalled,
      handleDisconnectWallet,
      isMobile
    }),
    [
      address,
      isSignWallet,
      setIsSignWallet,
      selectedNetwork,
      openWalletModal,
      handleSignWallet,
      walletSidebarOpen,
      setOpenWalletModal,
      handleToggleWalletSidebar,
      switchChainId,
      connector,
      setSelectedNetwork,
      currentChain,
      isSwitching,
      setIsSwitching,
      isDisabled,
      setIsDisabled,
      selectedWallet, setSelectedWallet,
      isConnected,
      isAuthenticated, setIsAuthenticated,
      disconnectCalled, setDisconnectCalled,
      handleDisconnectWallet,
      isMobile
    ]
  );
  return (
    <AppContext.Provider value={contextValues}>
      {children}
    </AppContext.Provider>
  );
};

export default AppRootContext;

export const useRootContext = () => {
  const {
    address,
    isSignWallet,
    setIsSignWallet,
    selectedNetwork,
    openWalletModal,
    handleSignWallet,
    walletSidebarOpen,
    setOpenWalletModal,
    handleToggleWalletSidebar,
    switchChainId,
    connector,
    setSelectedNetwork,
    currentChain,
    isSwitching,
    setIsSwitching,
    isDisabled,
    setIsDisabled,
    selectedWallet, setSelectedWallet,
    isConnected,
    isAuthenticated, setIsAuthenticated,
    disconnectCalled, setDisconnectCalled,
    handleDisconnectWallet,
    isMobile
  } = useContext(AppContext);

  return {
    address,
    isSignWallet,
    setIsSignWallet,
    selectedNetwork,
    openWalletModal,
    handleSignWallet,
    walletSidebarOpen,
    setOpenWalletModal,
    handleToggleWalletSidebar,
    switchChainId,
    connector,
    setSelectedNetwork,
    currentChain,
    isSwitching,
    setIsSwitching,
    isDisabled,
    setIsDisabled,
    selectedWallet, setSelectedWallet,
    isConnected,
    isAuthenticated, setIsAuthenticated,
    disconnectCalled, setDisconnectCalled,
    handleDisconnectWallet,
    isMobile
  };
};
